import { initializeApiClient } from './apiClient';

let initPromise = null;

export const initializeMsalInstance = async (msalInstance) => {
  if (initPromise) {
    return initPromise;
  }

  initPromise = (async () => {
    try {
      await msalInstance.initialize();
    } catch (initError) {
      if (initError?.errorCode === 'block_iframe_reload') {
        console.warn('MSAL: block_iframe_reload during init – continuing (iframe context)');
      } else {
        console.error('MSAL initialization failed:', initError);
        initPromise = null; // reset if failed
        return false;
      }
    }

    try {
      const response = await msalInstance.handleRedirectPromise();
      if (response) {
        msalInstance.setActiveAccount(response.account);
      }
    } catch (redirectError) {
      if (redirectError?.errorCode !== 'block_iframe_reload') {
        console.error('Error handling redirect:', redirectError);
      }
    }

    if (!msalInstance.getActiveAccount()) {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }

    try {
      initializeApiClient(msalInstance);
    } catch (error) {
      console.error('Error initializing API Client:', error);
    }

    return true;
  })();

  return initPromise;
};
